import {AbstractControl} from '@angular/forms';
import {LoeschenDialogComponent} from '@wba-ui-module/components/dialogs/loeschen-dialog/loeschen-dialog.component';
import {ElementRef, Injectable} from '@angular/core';
import {Subject} from 'rxjs';

declare let $;

@Injectable({
  providedIn: 'root'
})
export class EventUtils {
  public focusOut$ = new Subject<ElementRef>();

  static focus(el: HTMLElement, preventScroll = false) {
    setTimeout(() => el.focus({preventScroll}));
  }

  static collapseAndScrollTo(id: string) {
    if (!id) {
      return;
    }
    const elem = document.getElementById(id) ? document.getElementById(id).getElementsByClassName('collapse')[0] : null;
    if (elem) {
      $(elem).collapse('show');
      elem.scrollIntoView({inline: 'center', block: 'center', behavior: 'smooth'});
    }
  }

  // Imported from bootstrap 3.4.1 repo
  static isVisible(element) {
    if (!element) {
      return false;
    }

    if (element.style && element.parentNode?.style) {
      return element.style.display !== 'none' && element.parentNode.style.display !== 'none' && element.style.visibility !== 'hidden';
    }

    return false;
  }

  jaNeinBeforeChangedEvent = ({event, value}, control: AbstractControl, modalDialogElement: LoeschenDialogComponent, condition = true) => {
    if (!value && condition) {
      modalDialogElement.open(event.target)
      modalDialogElement.commitEvent.subscribe(() => control.patchValue(value));
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    return true;
  };

}
